import { FC } from 'react';

type MandatoryFieldProps = {
  className?: string;
};

const MandatoryField: FC<MandatoryFieldProps> = ({ className }) => (
  <span className={`text-danger ${className || ''}`}>*</span>
);

export default MandatoryField;
